"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "cartApiData", {
  enumerable: true,
  get: function get() {
    return _cartApiData["default"];
  }
});
Object.defineProperty(exports, "IPDATA_API_KEY", {
  enumerable: true,
  get: function get() {
    return _keys.IPDATA_API_KEY;
  }
});
Object.defineProperty(exports, "STORES", {
  enumerable: true,
  get: function get() {
    return _stores["default"];
  }
});
Object.defineProperty(exports, "STAGING_DOMAINS", {
  enumerable: true,
  get: function get() {
    return _stores.STAGING_DOMAINS;
  }
});
Object.defineProperty(exports, "STAGING_STORES", {
  enumerable: true,
  get: function get() {
    return _stores.STAGING_STORES;
  }
});
Object.defineProperty(exports, "getIrelandMigrationFeatureToggle", {
  enumerable: true,
  get: function get() {
    return _helpers.getIrelandMigrationFeatureToggle;
  }
});
exports["default"] = void 0;

var _cartApiData = _interopRequireDefault(require("./cartApiData"));

var _keys = require("./keys");

var _stores = _interopRequireWildcard(require("./stores"));

var _helpers = require("./stores/helpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  cdn: 'https://cdn.gymshark.com',
  getEnvironment: _helpers.getEnvironment,
  getStoreCode: _helpers.getStoreCode,
  getLiveStoreCode: _helpers.getLiveStoreCode,
  getCountryList: _helpers.getCountryList,
  api: {
    development: {
      endpoint: 'https://api.develop.gymshark.com'
    },
    staging: {
      endpoint: 'https://api.staging.gymshark.com'
    },
    production: {
      endpoint: 'https://api.gymshark.com'
    }
  },
  auth: {
    development: {
      domain: 'auth.develop.gymshark.com',
      clientID: 'TxYHIiPeout9P5xdFkDb2b592jbsO2Sk',
      redirectUri: 'https://callback.develop.gymshark.com/auth',
      audience: 'https://gateway.api.develop.gymshark.com',
      connection: 'Centralised-Login'
    },
    staging: {
      domain: 'auth.staging.gymshark.com',
      clientID: 't8Cj61FY7wpSeHVFfE0ot2yGbUaZgV14',
      redirectUri: 'https://callback.staging.gymshark.com/auth',
      audience: 'https://gateway.api.staging.gymshark.com',
      connection: 'Centralised-Login'
    },
    production: {
      domain: 'auth.gymshark.com',
      clientID: 'PSwn3mnQ64qR41c8qO4TZB2wtF73hmZw',
      redirectUri: 'https://callback.gymshark.com/auth',
      audience: 'https://gateway.api.gymshark.com',
      connection: 'Centralised-Login'
    }
  },
  gnatta: {
    development: {
      domain: 'https://contact.api.develop.gymshark.io'
    },
    staging: {
      domain: 'https://contact.api.staging.gymshark.io'
    },
    production: {
      domain: 'https://contact.api.gymshark.io'
    }
  },
  s3data: {
    development: {
      endpoint: 'https://config.develop.gymshark.io'
    },
    staging: {
      endpoint: 'https://config.staging.gymshark.io'
    },
    production: {
      endpoint: 'https://config.gymshark.io'
    }
  },
  stores: _stores["default"]
};
exports["default"] = _default;